import React from 'react';

// Cue type → short code + accent token. The accent drives both the chip text
// colour and a 14%-alpha translucent background (via color-mix), matching the
// redesign mockups. SHOW_START ("GO") and SECTION_BREAK ("§") are hard dividers,
// rendered as an inverted high-contrast chip instead of a tinted one.
export const TYPE_META = {
  SEGMENT:              { short: 'SEG',  token: '--t-seg' },
  CAMERA:               { short: 'CAM',  token: '--t-camera' },
  REPLAY:               { short: 'RPL',  token: '--t-replay' },
  GRAPHIC:              { short: 'GFX',  token: '--t-graphic' },
  AUDIO:                { short: 'AUD',  token: '--t-audio' },
  RECORD_STREAM:        { short: 'REC',  token: '--t-rec' },
  NOTE:                 { short: 'NOTE', token: '--t-note' },
  BREAK:                { short: 'BRK',  token: '--t-break' },
  VT_VOX:               { short: 'VTV',  token: '--t-vtvox' },
  VT:                   { short: 'VT',   token: '--t-vt' },
  PRESENTERS_TO_CAMERA: { short: 'PTC',  token: '--t-ptc' },
  GROUP:                { short: 'GRP',  token: '--t-group' },
  PRE_SHOW:             { short: 'PRE',  token: '--t-preshow' },
  SHOW_START:           { short: 'GO',   token: null, divider: true },
  SECTION_BREAK:        { short: '§',    token: null, divider: true },
};

// Translucent-chip style for a type (or the inverted divider style). Exported so
// the modern spine's type tags render identically without duplicating the map.
export function cueTypeChipStyle(type) {
  const meta = TYPE_META[type] || TYPE_META.NOTE;
  if (meta.divider) return { background: 'var(--text)', color: 'var(--bg)' };
  return {
    background: `color-mix(in srgb, var(${meta.token}) 14%, transparent)`,
    color: `var(${meta.token})`,
  };
}

export default function CueTypeBadge({ type, compact = false }) {
  const meta = TYPE_META[type] || TYPE_META.NOTE;
  return (
    <span
      className="inline-flex items-center rounded-[5px] font-medium uppercase align-middle"
      style={{
        ...cueTypeChipStyle(type),
        padding: '3px 8px',
        fontSize: '10px',
        letterSpacing: '.06em',
        lineHeight: 1,
      }}
    >
      {compact ? meta.short : type}
    </span>
  );
}

// Back-compat alias — kept in case anything references the old export name.
export { TYPE_META as CUE_TYPE_STYLES };
